import {VisuallyHidden} from '@radix-ui/react-visually-hidden';
import React from 'react';

import Image from '@/components/Image/Image';
import {getImageByViewType, IMAGE_VIEW_TYPES} from '@/consts/icc/imageViewTypes';
import {AUTO_DELIVERY_ITEM_QUANTITY_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import {getFormattedAriaLabel} from '@/services/accessibilityService';
import {twx} from '@/utils/tailwindUtils';

const AutoDeliveryOrder = ({className, products, children}) => {
    if (!products?.length) return;

    return (
        <div className={twx('px-4 pb-4 pt-10', className)}>
            {children}
            <ul>
                {products.map((product, i) => {
                    return <ProductListItem product={product} key={i} />;
                })}
            </ul>
        </div>
    );
};

export default AutoDeliveryOrder;

const ProductListItem = ({product}) => {
    const {name, images, quantity, isOutOfStock} = product;
    const {link} = getImageByViewType(images, IMAGE_VIEW_TYPES.SMALL) || {};
    const quantityAriaLabel = getFormattedAriaLabel(AUTO_DELIVERY_ITEM_QUANTITY_ARIA_LABEL, quantity);

    return (
        <li className='flex items-center gap-2 border-b border-primary-dark-15 py-4 last:border-none md:py-2'>
            <Image
                src={link}
                className={twx(
                    'h-16 w-16 rounded-md bg-primary-dark-5 object-contain ml:bg-romance',
                    isOutOfStock && 'opacity-40'
                )}
            />
            <div className={twx('flex-1', isOutOfStock && 'opacity-40')}>
                {name}
                <VisuallyHidden>{quantityAriaLabel}</VisuallyHidden>
            </div>
            <div className='rounded bg-primary-dark-5 px-2 py-1 font-bold ml:bg-romance' aria-hidden='true'>
                x{quantity}
            </div>
        </li>
    );
};
